import React, { createContext, PureComponent } from 'react';
import { IAppState } from 'types/ApplicationState';
import { AppState } from '../config/config';

interface IProps {
  children: JSX.Element;
}

const initialValue = {
  appState: undefined,
  setAppState: () => undefined,
};

export const AppStateContext = createContext<Partial<IAppState>>(initialValue);

export class AppStateContextProvider extends PureComponent<IProps, Partial<IAppState>> {
  constructor(props) {
    super(props);
    this.state = {
      appState: undefined,
    };
  }

  setAppState = (status: AppState) => {
    this.setState({ appState: status });
  };

  render() {
    const { Provider } = AppStateContext;
    const { children } = this.props;
    return (
      <Provider
        value={{
          ...this.state,
          setAppState: this.setAppState,
        }}
      >
        {children}
      </Provider>
    );
  }
}
